import { Auth } from "../../auth";
import { properties } from "../../constants/Propertise";
import base64 from "base-64";
import {
  setBackgroundColorRevise,
  setHeaderBackgroundColourRevise,
} from "../ThemeOptions";

const SET_LOGIN_PENDING = "SET_LOGIN_PENDING";
const SET_LOGIN_SUCCESS = "SET_LOGIN_SUCCESS";
const SET_LOGIN_ERROR = "SET_LOGIN_ERROR";

export function login(loginData, otp) {
  return (dispatch) => {
    dispatch(setLoginPending(true));
    let loginUrl = `${process.env.REACT_APP_USERMANAGEMENT_API_URL}OTP/v1/validateOTP/${otp}`;
    // let loginUrl = process.env.REACT_APP_API_URL + "login";

    const loginObj = {
      username: loginData.username.toLowerCase(),
      password: loginData.password,
    };
    let headers = new Headers();
    headers.append(
      "Authorization",
      "Basic " +
        base64.encode(loginObj["username"] + ":" + loginObj["password"])
    );
    let requestOptions = {
      method: "GET",
      headers: headers,
      redirect: "follow",
    };

    fetch(loginUrl, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        let details = JSON.parse(result);
        if (details["errorCode"] === undefined) {
          localStorage.setItem(
            "onevubasicauthtoken",
            details["basicAuthToken"]
          );
          localStorage.setItem("refreshToken", details["bearerToken"]);
          localStorage.setItem(
            "oneviewprojects",
            JSON.stringify(details["projects"])
          );
          localStorage.setItem("roles", details["roles"]);
          localStorage.setItem("onevuusername", details["username"]);
          localStorage.setItem("selectedLang", "En");
          localStorage.setItem("defaultLang", "En");
          //localStorage.setItem('selectedProject',details['projects'][0]['id']);
          localStorage.setItem("selectedProject", 1);
          Auth.authenticateUser(
            loginObj.username,
            loginUrl,
            details["basicAuthToken"]
          );
          Auth.updateUserInformation(details);

          if (details["userPreferences"] !== null) {
            let { id, sidebarTheme, headerTheme } = details["userPreferences"];
            localStorage.setItem("id", id);
            localStorage.setItem("oneviewheaderTheme", headerTheme);
            localStorage.setItem("oneviewsiderbarTheme", sidebarTheme);

            dispatch(setHeaderBackgroundColourRevise(headerTheme));
            dispatch(setBackgroundColorRevise(sidebarTheme));
          } else {
            localStorage.setItem("id", null);
            localStorage.setItem(
              "oneviewheaderTheme",
              "bg-night-sky header-text-light"
            );
            localStorage.setItem(
              "oneviewsiderbarTheme",
              "bg-royal sidebar-text-light"
            );

            // this.props.setHeaderBackgroundColourRevise('bg-night-sky header-text-light')
            // this.props.setBackgroundColorRevise('bg-royal sidebar-text-light');
          }

          dispatch(setLoginSuccess(details["bearerToken"], true, true));
        } else {
          dispatch(setLoginError(properties.userLoginError));
        }
      })
      .catch((error) => {
        dispatch(setLoginError(properties.userLoginError));
      });
  };
}

function setLoginPending(isLoginPending) {
  return {
    type: SET_LOGIN_PENDING,
    isLoginPending,
  };
}

function setLoginSuccess(userToken, isLoginSuccess, authDone) {
  return {
    type: SET_LOGIN_SUCCESS,
    userToken,
    isLoginSuccess,
    authDone,
  };
}

function setLoginError(loginError) {
  return {
    type: SET_LOGIN_ERROR,
    loginError,
  };
}

export default function newLoginReducer(
  state = {
    isLoginSuccess: false,
    isLoginPending: false,
    loginError: false,
    authDone: false,
    apiError: false,
    userToken: null,
  },
  action
) {
  switch (action.type) {
    case SET_LOGIN_PENDING:
      return Object.assign({}, state, {
        isLoginPending: action.isLoginPending,
        isLoginSuccess: false,
        loginError: false,
        apiError: false,
      });

    case SET_LOGIN_SUCCESS:
      return Object.assign({}, state, {
        isLoginSuccess: action.isLoginSuccess,
        isLoginPending: false,
        loginError: false,
        apiError: false,
        authDone: action.authDone,
        userToken: action.userToken,
      });

    case SET_LOGIN_ERROR:
      return Object.assign({}, state, {
        apiError: action.loginError,
        isLoginPending: false,
        isLoginSuccess: false,
        loginError: true,
      });

    default:
      return state;
  }
}
